import { useCallback, useEffect } from 'react'
import { useBlocker, useLocation } from 'react-router-dom'
import rootStore from '@/app/store'
import { observer } from 'mobx-react'

const NavigationBlocker = observer(() => {
  const { chat } = rootStore
  const currentLocation = useLocation()

  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  const blocker = useBlocker(({ nextLocation }) => {
    const nextFullPath = `${nextLocation.pathname}${nextLocation.search}`
    const currentFullPath = `${currentLocation.pathname}${currentLocation.search}`
    return chat.hasPendingPlugins && nextFullPath !== currentFullPath
  })

  useEffect(() => {
    if (chat.hasPendingPlugins) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [chat.hasPendingPlugins, handleBeforeUnload])

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const proceed = window.confirm(
        'Tienes acciones pendientes. ¿Estás seguro de querer salir de esta página?',
      )
      if (proceed) {
        chat.clearThread()
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, chat])

  return null
})

export default NavigationBlocker
